import {Component, Input, TemplateRef} from '@angular/core';
import {Lookups} from "@model";
import {TooltipPosition, TooltipTheme} from "./tooltip.enums";

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.scss',
    standalone: false
})
export class TooltipComponent {
  @Input() hrLabel?: string | undefined;
  @Input() enLabel?: string | undefined;
  @Input() siLabel?: string | undefined;
  @Input() itLabel?: string | undefined;
  @Input() srLabel?: string | undefined;
  @Input() bsLabel?: string | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() position: TooltipPosition = TooltipPosition.DEFAULT;
  @Input() theme: TooltipTheme = TooltipTheme.DEFAULT;
  content: TemplateRef<any> | undefined
  tooltip = '';
  left = 0;
  top = 0;
  visible = false;

  constructor() {
  }

  ngOnInit(): void {
  }
}
